import {
  Avatar,
  BodyLong,
  Button,
  Heading,
  HorizontalSpace,
  Loader,
  Textarea,
  VerticalSpace
} from '@elhub/ds-components'

import React, { useState } from 'react'

interface FeedbackProps {
  location: string
}

enum FeedbackType {
  POSITIVE = 'POSITIVE',
  NEUTRAL = 'NEUTRAL',
  NEGATIVE = 'NEGATIVE'
}
const Feedback = ({ location }: FeedbackProps) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const [feedback, setFeedback] = useState<FeedbackType | undefined>(undefined)
  const [comment, setComment] = useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = useState<boolean>(false)
  const [successful, setSuccessful] = useState<boolean | undefined>(undefined)

  const handleFeedback = (feedback: FeedbackType) => {
    setExpanded(true)
    setFeedback(feedback)
  }

  const handleCancel = () => {
    setExpanded(false)
    setFeedback(undefined)
  }

  const handleSend = async () => {
    setSubmitted(true)
    setExpanded(false)
    setFeedback(undefined)

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ location, feedback, comment })
    }
    try {
      // await fetch('http://localhost:8082/energy-data/v0/feedback', requestOptions)
      await fetch(window.location.origin + '/energy-data/v0/feedback', requestOptions)
        .then((response) => response.status)
        .then((status) => (status === 200 ? setSuccessful(true) : setSuccessful(false)))
    } catch (e) {
      setSuccessful(false)
    }
  }

  return (
    <>
      {!submitted
        ? (
            !expanded
              ? (
                <>
                  <Heading>How do you like this page?</Heading>
                  <VerticalSpace size='1' />
                  <div style={{ display: 'flex' }}>
                    <Avatar
                      src='/resources/ElhubSmiley01.png'
                      size='small'
                      onClick={() => handleFeedback(FeedbackType.POSITIVE)}
                    />
                    <HorizontalSpace size='1' />
                    <Avatar
                      src='/resources/ElhubSmiley03.png'
                      size='small'
                      onClick={() => handleFeedback(FeedbackType.NEUTRAL)}
                    />
                    <HorizontalSpace size='1' />
                    <Avatar
                      src='/resources/ElhubSmiley05.png'
                      size='small'
                      onClick={() => handleFeedback(FeedbackType.NEGATIVE)}
                    />
                  </div>
                </>
                )
              : (
                <>
                  <Heading>How can we improve? (Optional)</Heading>
                  <Textarea
                    label=''
                    resize
                    size='small'
                    description='Your answer will help with future prioritisations and improvements.'
                    rows={5}
                    onBlur={(e) => setComment(e.target.value)}
                  />
                  <BodyLong style={{ margin: '5px 0' }}>Don't write information about yourself or others.</BodyLong>
                  <div>
                    <Button variant='primary' onClick={() => handleSend()}>
                      Send feedback
                    </Button>
                    <HorizontalSpace size='1' />
                    <Button variant='secondary' onClick={() => handleCancel()}>
                      Cancel
                    </Button>
                  </div>
                </>
                )
          )
        : (
          <>
            {successful === undefined && <Loader />}
            {successful === false && <Heading>Error sending feedback, please try again later</Heading>}
            {successful === true && <Heading>Thanks for the feedback, we appreciate it!</Heading>}
          </>
          )}
    </>
  )
}

export default Feedback
